import '../../../../src/assets/scripts/sections/product';

import $ from 'jquery';
import populateCarousels from './populateCarousels';
import { initProductCarousels } from './carousel';
import onResize from './onResize';
import variantSelectors from './variantSelectors';
import themeEditor from './themeEditor';

const ProductOverview = () => {
  // This needs to be on every page for quickview...kind of hacky, need to refactor later
  variantSelectors();
  onResize();

  if ($('[data-section-type="product"] [data-product-json]').length === 0) { return; }

  populateCarousels();
  initProductCarousels();
  themeEditor();

  // Slightly hacky, but make sure the right image is shown on page
  if ($('[data-custom-variant-selector]').is('select')) {
    $('[data-custom-variant-selector]').selectric('refresh').trigger('change');
  } else {
    $('.ProductOption__variant--selected').trigger('click');
  }

  $(window).on('breakpointChange', () => {
    initProductCarousels();
  });
};

export { ProductOverview };